import * as React from "react";
import { StaticImageData } from "next/image";

import { LOGO_STRIPS_DEFAULTS, L_03 } from "@stadium/shared/src/helpers/plasmic/static-slices";

import ResponsiveLogoGrid from "./index.client";
import styles from "./main.module.scss";

export interface CompanyLogo {
  logoMobile?: string | StaticImageData;
  logoTablet?: string | StaticImageData;
  logoDesktop?: string | StaticImageData;
  alt: string;
}

export interface LS03Props {
  logoStripEyebrow?: string;
  logoStripHeading?: string;
  companyLogo1?: CompanyLogo;
  companyLogo2?: CompanyLogo;
  companyLogo3?: CompanyLogo;
  companyLogo4?: CompanyLogo;
  companyLogo5?: CompanyLogo;
  companyLogo6?: CompanyLogo;
  backgroundColor?: string;
  className?: string;
}

const LS03: React.FC<Readonly<LS03Props>> = ({
  logoStripEyebrow = LOGO_STRIPS_DEFAULTS[L_03].logoStripEyebrow,
  logoStripHeading = LOGO_STRIPS_DEFAULTS[L_03].logoStripHeading,
  companyLogo1 = {
    logoMobile: LOGO_STRIPS_DEFAULTS[L_03].companyLogo1,
    logoTablet: LOGO_STRIPS_DEFAULTS[L_03].companyLogo1,
    logoDesktop: LOGO_STRIPS_DEFAULTS[L_03].companyLogo1,
    alt: LOGO_STRIPS_DEFAULTS[L_03].companyLogo1Alt,
  },
  companyLogo2 = {
    logoMobile: LOGO_STRIPS_DEFAULTS[L_03].companyLogo2,
    logoTablet: LOGO_STRIPS_DEFAULTS[L_03].companyLogo2,
    logoDesktop: LOGO_STRIPS_DEFAULTS[L_03].companyLogo2,
    alt: LOGO_STRIPS_DEFAULTS[L_03].companyLogo2Alt,
  },
  companyLogo3 = {
    logoMobile: LOGO_STRIPS_DEFAULTS[L_03].companyLogo3,
    logoTablet: LOGO_STRIPS_DEFAULTS[L_03].companyLogo3,
    logoDesktop: LOGO_STRIPS_DEFAULTS[L_03].companyLogo3,
    alt: LOGO_STRIPS_DEFAULTS[L_03].companyLogo3Alt,
  },
  companyLogo4 = {
    logoMobile: LOGO_STRIPS_DEFAULTS[L_03].companyLogo4,
    logoTablet: LOGO_STRIPS_DEFAULTS[L_03].companyLogo4,
    logoDesktop: LOGO_STRIPS_DEFAULTS[L_03].companyLogo4,
    alt: LOGO_STRIPS_DEFAULTS[L_03].companyLogo4Alt,
  },
  companyLogo5 = {
    logoMobile: LOGO_STRIPS_DEFAULTS[L_03].companyLogo5,
    logoTablet: LOGO_STRIPS_DEFAULTS[L_03].companyLogo5,
    logoDesktop: LOGO_STRIPS_DEFAULTS[L_03].companyLogo5,
    alt: LOGO_STRIPS_DEFAULTS[L_03].companyLogo5Alt,
  },
  companyLogo6 = {
    logoMobile: LOGO_STRIPS_DEFAULTS[L_03].companyLogo6,
    logoTablet: LOGO_STRIPS_DEFAULTS[L_03].companyLogo6,
    logoDesktop: LOGO_STRIPS_DEFAULTS[L_03].companyLogo6,
    alt: LOGO_STRIPS_DEFAULTS[L_03].companyLogo6Alt,
  },
  backgroundColor = LOGO_STRIPS_DEFAULTS[L_03].backgroundColor,
  className,
}) => {
  const companyLogos = [
    companyLogo1,
    companyLogo2,
    companyLogo3,
    companyLogo4,
    companyLogo5,
    companyLogo6,
  ];

  return (
    <section style={{ backgroundColor }} className={`${styles.lS03Section} ${className || ""}`}>
      <div className={styles.sectionContainer}>
        <div className={styles.lS03container}>
          <div className={styles.logoStripSection}>
            <div className={styles.logoStripLeft}>
              <p className={styles.eyebrow}>{logoStripEyebrow}</p>
              <h2 className={styles.logoStripHeading}>{logoStripHeading}</h2>
            </div>

            <div className={styles.logoStripRight}>
              <ResponsiveLogoGrid companyLogos={companyLogos} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default LS03;
